export const PagesPrefixEnum = 'locale-'
